module.exports = __webpack_public_path__ + "img/veke-logo-black.8f5dffbb.svg";